import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import { HttpClient, HttpEventType } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { merge, of } from "rxjs";
import {
  catchError,
  debounceTime,
  filter,
  finalize,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import { User } from "src/app/_models";
import { AccountService } from "src/app/_services";
import { InsumoService } from "src/app/_services/insumos.service";
import { UploadService } from "src/app/_services/upload.service";
import { environment } from "src/environments/environment";
import * as uuid from "uuid";
import { filterParams, InsumoList } from "../../_models/insumos";
import { CompetenceDatePipe } from "../../_pipes/competence-date.pipe";
import { DeliveryDatePipe } from "../../_pipes/deliveryDate.pipe";
import { InsumosFieldsService } from "../../_services/insumosFields.service";
import { TablePeriodicElement } from "../insumo-field-config/insumo-field-config.component";
import { SecondResponsibleInputComponent } from "src/app/_components/second-responsible-input/second-responsible-input.component";

@Component({
  selector: "app-consultar-insumos",
  templateUrl: "./consultar-insumos.component.html",
  styleUrls: ["./consultar-insumos.component.css"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  providers: [CompetenceDatePipe, DeliveryDatePipe],
})
export class ConsultarInsumosComponent implements OnInit, AfterViewInit {
  @ViewChild(SecondResponsibleInputComponent) secondResponsibleInput: SecondResponsibleInputComponent;
  selection = new SelectionModel<InsumoList>(true, []);

  submitted = false;
  fields: any[] = [];
  isChecked = true;

  visualizationMode = "cards";
  insumoList = [];

  pageSize = this.visualizationMode === "list" ? 5 : 6;
  pageSizeOptions =
    this.visualizationMode === "list"
      ? [1, 5, 10, 25, 50, 100]
      : [1, 6, 12, 24, 48, 96];

  anexoInsumo: FormGroup;
  formUpdate: FormGroup;
  formDeadLine: FormGroup;
  formGroup: FormGroup;
  formFiltro: FormGroup;
  formChangeVersion: FormGroup;

  actualInsumoId: any;
  insumoVersionList: string[] = [];
  insumoSegmentList: string[] = [];
  tempInsumoId: any;
  user: User;
  userToken: string;
  insumo: InsumoList = {} as InsumoList;

  searchUserCtrl1 = new FormControl();
  searchUserCtrl2 = new FormControl();
  searchUserCtrlFiltro = new FormControl();

  errorMsg: string;
  filteredUsers1: any;
  filteredUsers2: any;
  filteredUsersFilter: any;
  isLoading = false;
  actualInsumoLength: number = 0;

  files = [];
  attachments: any[] = [];
  anexoDownload: string = environment.apiUrl + "/download/anexo-insumo/";

  formData: MatTableDataSource<InsumoList>;
  dataSourceForDownload: MatTableDataSource<any>;
  dataSource = new MatTableDataSource<InsumoList>();
  dataSourceLength: number = 0;
  isDownloadProcess: boolean = false;
  expandedElement: InsumoList;
  expandedElement2: InsumoList;

  isAuditInsumosUser: boolean = false;

  filterParams: filterParams;

  categoriaOptions: string[] = [
    'FIXA', 'AJUSTES_B2B', 'AJUSTES_B2C', 'ALTA EASY', 'ALTA TOURIST', 'ALTA_CROSS',
    'ALTA_EASY', 'ALTA_FIXA', 'ALTA_FIXA_AVANCADA', 'ALTA_FIXA_BASICA', 'ALTA_INVASAO',
    'ALTA_MIGR_TCNL_FIXA', 'ALTA_PF', 'ALTA_PJ', 'ALTA_PJ_CART', 'ALTA_PJ_RESP',
    'ALTA_POS', 'ALTA_POS_FRESH', 'ALTA_PRE', 'ALTA_PRE_RECARGA', 'ALTA_SVA',
    'ALTA_SVA_DIGITAL', 'ALTA_SVA_TV', 'ALTA_SVA_VOZ_DADOS', 'ALTA_TOURIST',
    'ALTA_TRDIN', 'ALTA_VOZ_FIXA', 'ANTI_FAT', 'ANTI_FAT_CXP', 'APARELHO_EASY',
    'APARELHO_FATURADO', 'APARELHO_MOVEL_CROSS', 'APARELHOS_TLV', 'APVD', 'APVD_CXP',
    'ATVC_SVA_DIGITAL', 'BAIXA_ALTA_CROSS', 'BAIXA_APARELHO_EASY',
    'BAIXA_APARELHO_FATURADO', 'BAIXA_APARELHO_MOVEL_CROSS', 'BAIXA_ATIVACAO_INDEVIDA',
    'BAIXA_BL_ADESAO', 'BAIXA_BL_ADESAO_TLV', 'BAIXA_CAMPANHA_FTTH',
    'BAIXA_CAMPANHA_RENOVACAO', 'BAIXA_COBRE_TLV', 'BAIXA_Combate_CROSS', 'BAIXA_EASY',
    'BAIXA_FAT', 'BAIXA_FIBRA_CROSS', 'BAIXA_FIXA_AVANCADA', 'BAIXA_FIXA_BASICA',
    'BAIXA_FTTC_CROSS', 'BAIXA_FTTH_CROSS', 'BAIXA_FTTH_TLV',
    'BAIXA_GRUPO_ALTA_SVA_TLV', 'BAIXA_IPTV_CROSS', 'BAIXA_IPTV_TLV',
    'BAIXA_MUDANCA_TITULARIDADE', 'BAIXA_PF', 'BAIXA_PF_ITV_MD', 'BAIXA_PJ',
    'BAIXA_PJ_RESP', 'BAIXA_POS_FRESH', 'BAIXA_PRE_NATIMORTO',
    'BAIXA_Premiere+_CROSS', 'BAIXA_PTO_ADC_WIFI_CROSS', 'BAIXA_SVA',
    'BAIXA_SVA_DIGITAL', 'BAIXA_SVA_ITV_MD', 'BAIXA_TERMINAL_CROSS',
    'BAIXA_TROCAS_TLV', 'BAIXA_VIVOTECH_TLV', 'BAIXA_VOIP_TLV', 'BAIXA_VOZ_CROSS',
    'BAIXA_VOZ_FIXA', 'BAIXA_VOZ_FIXA_TLV', 'BAIXA_VOZ_MOVEL_TLV', 'BAIXA_XDSL_CROSS',
    'BAIXAS_SERVICOS_DIGITAIS', 'BL_ADESAO_TLV', 'BLINDAGEM_CROSS',
    'CALCULO_PRONTO_B2B', 'CAMPANHA_FTTH', 'CAMPANHA_RENOVACAO', 'CARTEIRA',
    'CHARGEBACK_ESTQ_AVANC', 'COBRE_TLV', 'Combate_CROSS', 'Curta!_CROSS',
    'DELTA_EASY', 'DogTV_CROSS', 'DOWN_COBRAR', 'DOWN_COBRAR_FIXA', 'DOWN_PAGAR',
    'DOWN_PAGAR_FIXA', 'DOWN_PAGAR_MIGR_TCNL_FIXA', 'EMPACOTAMENTO_CROSS',
    'ESTORNO_ESTQ_AVANC', 'ESTORNO_MARGEM', 'ESTQ_AVANC', 'ESTQ_AVANC_RENOVA',
    'FAT', 'FAT_CXP', 'FIBRA_CROSS', 'FIBRA_LITE', 'FIDELIZACAO_FIXA_TLV',
    'FIDELIZACAO_MIGRACAO_TLV', 'FTTC_CROSS', 'FTTH_CROSS', 'FTTH_TLV', 'FWT_CROSS',
    'GRUPO_ALTA_SVA_TLV', 'IPTV_CROSS', 'IPTV_TLV', 'MIG_DE_TEC_DADOS_TLV',
    'MIG_DE_TEC_VOZ_TLV', 'MIGRACAO_BL', 'MIGRACAO_BL_TLV',
    'MIGRACAO_DE_TECNOLOGIA_CROSS', 'MIGRACAO_FIBRA_CROSS', 'MIGRACAO_PF',
    'MIGRACAO_SVA', 'MIGRACAO_TLV', 'MUDANCA_TITULARIDADE', 'MULTA_INVASAO_PRE',
    'NAO DEFINIDO', 'Pacote_Esportes+_CROSS', 'Pacote_Internacional_CROSS',
    'Pacote_On_Demand_Adulto_MANTOMAN_CROSS', 'Pacote_On_Demand_Philos_CROSS',
    'PEN_BOX_TLV', 'PEN_CROSS', 'PENALIZACAO_INVASAO', 'Premiere+_CROSS',
    'PRTA_INFT', 'REM_FIXA_PA_TLV', 'RENTABILIZACAO_CROSS',
    'RENTABILIZACAO_DADOS_TLV', 'RENTABILIZACAO_TV_TLV', 'RENTABILIZACAO_VOZ_TLV',
    'REVENDA_ENERGIA', 'SERVICOS_DIGITAIS', 'Sexy_Hot_CROSS', 'Telecine_CROSS',
    'TERMINAL_CROSS', 'TROCA_PRE', 'TROCAS_TLV', 'UPGRADE', 'UPGRADE_FIBRA_CROSS',
    'UPGRADE_FIXA', 'UPGRADE_MIGR_TCNL_FIXA', 'VENDA_PJ', 'VENDA_PJ_CART',
    'VENDA_PJ_RESP', 'VENDA_VOZ_FIXA', 'VIVO_GURU_CROSS', 'VIVOTECH_TLV',
    'VOIP_TLV', 'VOZ_CROSS', 'VOZ_FIXA_TLV', 'VOZ_MOVEL_TLV', 'XDSL_CROSS',
    'XDSL_TLV'
  ];
  filteredCategorias: string[] = [];

  @ViewChild("fileUpload", { static: false }) fileUpload: ElementRef;
  @ViewChild("closeModalAlterarResponsavel")
  closeModalAlterarResponsavel: ElementRef;
  @ViewChild("closeModalAlterarDeadLine")
  closeModalAlterarDeadLine: ElementRef;
  @ViewChild("closeModalExcluir") closeModalExcluir: ElementRef;
  @ViewChild("closeModalEncerrar") closeModalEncerrar: ElementRef;
  @ViewChild("closeConfirmDoc") closeConfirmDoc: ElementRef;
  @ViewChild("closeModalEncerradosAlert") closeEncerradosAlert: ElementRef;
  @ViewChild("encerradosNada") encerradosNada: ElementRef;
  @ViewChild("closeModalVersion") closeModalVersion: ElementRef;
  @ViewChild("exportModal") exportModal: ElementRef;
  @ViewChild("modalclose") modalclose: ElementRef;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private insumosService: InsumoService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private http: HttpClient,
    private uploadService: UploadService,
    private insumoFieldService: InsumosFieldsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.user = this.accountService.userValue.user;
    this.isAuditInsumosUser =
      this.accountService.userValue.user.userType == "AUDITORIA_INSUMOS";
    this.userToken = this.accountService.userValue.token;
  }

  ngOnInit(): void {
    this.formChangeVersion = this.formBuilder.group({
      version: ["", Validators.required],
      justificativa: ["", Validators.required],
    });

    this.anexoInsumo = this.formBuilder.group({
      justify: ["", [Validators.minLength(3), Validators.maxLength(300)]],
    });

    this.formUpdate = this.formBuilder.group({
      responsibleUpload: ["", [Validators.required]],
      secondResponsibleUpload: [null],
      analysisUpload: ["", [Validators.required]],
      justify: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(300),
        ],
      ],
    });

    this.formDeadLine = this.formBuilder.group({
      deadline: ["", [Validators.required]],
      justify: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(300),
        ],
      ],
    });

    this.formFiltro = this.formBuilder.group({
      email: [""],
      segment: [""],
      insumoName: [""],
      status: [""],
      competence: [""],
      competenceStatus: [""],
      insumoId: [""],
      usoDoInsumo: [""],
      categoria: [""],
    });

    this.categoriaOptions.sort((a, b) => a.localeCompare(b, 'pt-BR'));
    this.filteredCategorias = this.categoriaOptions;

    this.searchUserCtrl1.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredUsers1 = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.http
            .get(`${environment.apiUrl}/api/user/search?email=${value}`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        )
      )
      .subscribe((data) => {
        if (data == undefined) {
          this.errorMsg = data["Error"];
          this.filteredUsers1 = [];
        } else {
          this.errorMsg = "";
          this.filteredUsers1 = data;
        }
      });

    this.searchUserCtrl2.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredUsers2 = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.http
            .get(`${environment.apiUrl}/api/user/search?email=${value}`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        )
      )
      .subscribe((data) => {
        if (data == undefined) {
          this.errorMsg = data["Error"];
          this.filteredUsers2 = [];
        } else {
          this.errorMsg = "";
          this.filteredUsers2 = data;
        }
      });

    this.searchUserCtrlFiltro.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredUsersFilter = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.http
            .get(`${environment.apiUrl}/api/user/search?email=${value}`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        )
      )
      .subscribe((data) => {
        if (data == undefined) {
          this.errorMsg = data["Error"];
          this.filteredUsersFilter = [];
        } else {
          this.errorMsg = "";
          this.filteredUsersFilter = data;
        }
      });

    this.getInsumosFieldsSegmento();

    this.route.queryParams.subscribe((params) => {
      this.filterParams = {
        id: +params["insumoId"] || 0,
        name: params["name"] || "",
        email: params["email"] || "",
        segment: params["segment"] || "TODOS",
        status: params["status"] || "TODOS",
        competence: params["competence"] || "",
        competenceStatus: params["competenceStatus"] || "TODOS",
        userId: +params["userId"] || this.user.id,
        usoDoInsumo: params["usoDoInsumo"] || "",
        categoria: params["categoria"] || "",
      };

      this.formFiltro.patchValue({
        email: this.filterParams.email,
        segment: this.filterParams.segment,
        insumoName: this.filterParams.name,
        status: this.filterParams.status,
        competenceStatus: this.filterParams.competenceStatus,
        competence: this.filterParams.competence,
        insumoId: this.filterParams.id,
        usoDoInsumo: this.filterParams.usoDoInsumo,
        categoria: this.filterParams.categoria,
      });

      const page = +params["page"] || 0;
      const size = +params["size"] || 10;
      const sort = params["sort"] || "id";
      const order = params["order"] || "desc";

      this.loadFilteredInsumos(page, size, sort, order);
    });
  }

  ngAfterViewInit() {
    this.paginator.pageIndex = 0;
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(tap(() => this.filter()))
      .subscribe();
  }

  private loadFilteredInsumos(page: number, size: number, sort: string, order: string) {
  this.insumosService
    .getInsumoPageableConsult(
      page,
      size,
      sort,
      order,
      this.filterParams.name,
      this.filterParams.userId,
      this.filterParams.email,
      this.filterParams.segment,
      this.filterParams.status,
      this.filterParams.competence,
      this.filterParams.competenceStatus,
      this.filterParams.id,
      this.filterParams.usoDoInsumo || "",
      this.filterParams.categoria || ""
    )
    .subscribe((data) => {
      this.dataSource = new MatTableDataSource(data["content"]);
      this.insumoList = data.content;
      this.dataSourceLength = data.totalElements;
      this.formData = this.dataSource;
    });
}


  filter() {
    this.validationFilterRequisition();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        name: this.filterParams.name,
        userId: this.filterParams.userId,
        email: this.filterParams.email,
        segment: this.filterParams.segment,
        status: this.filterParams.status,
        competence: this.filterParams.competence,
        competenceStatus: this.filterParams.competenceStatus,
        insumoId: this.filterParams.id,
        usoDoInsumo: this.filterParams.usoDoInsumo,
        categoria: this.filterParams.categoria,
        sort: this.sort.active,
        order: this.sort.direction,
        page: this.paginator.pageIndex,
        size: this.paginator.pageSize,
      },
      queryParamsHandling: "merge",
    });
  }

  changeVisualizationMode(mode) {
    this.visualizationMode = mode.value;

    this.pageSize = this.visualizationMode === "list" ? 5 : 6;
    this.pageSizeOptions =
      this.visualizationMode === "list"
        ? [1, 5, 10, 25, 50, 100]
        : [1, 6, 12, 24, 48, 96];
  }

  OnInitializeDataSource() {
    this.insumosService
      .getInsumoPageableConsult(
        0,
        this.pageSize,
        "id",
        "desc",
        this.filterParams.name,
        this.filterParams.userId,
        this.filterParams.email,
        this.filterParams.segment,
        this.filterParams.status,
        this.filterParams.competence,
        this.filterParams.competenceStatus,
        this.filterParams.id,
        this.filterParams.usoDoInsumo || "",
        this.filterParams.categoria || ""
      )
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data["content"]);
        this.insumoList = data.content;
        this.dataSourceLength = data.totalElements;
        this.formData = this.dataSource;
      });
  }

  resetFilterParams() {
    this.filterParams = {
      id: 0,
      name: "",
      email: "",
      segment: "TODOS",
      status: "TODOS",
      competence: "",
      competenceStatus: "VIGENTE",
      userId: this.user.id,
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        status: this.filterParams.status,
        competenceStatus: this.filterParams.competenceStatus,
      },
    });
  }

  onReset() {
    this.formFiltro.reset();
    this.searchUserCtrlFiltro.reset();
    this.resetFilterParams();
  }

  validationFilterRequisition() {
    const filtro = this.formFiltro.value;

    if (filtro.insumoName === "" || filtro.insumoName === null) {
      filtro.insumoName = "";
    }

    if (filtro.userId === "" || filtro.userId === null) {
      filtro.userId = this.user.id;
    }

    if (filtro.email === "" || filtro.email === null) {
      filtro.email = "";
    }

    if (filtro.segment === "" || filtro.segment === null) {
      filtro.segment = "TODOS";
    }

    if (filtro.status === "" || filtro.status === null) {
      filtro.status = "ATIVO";
    }

    if (filtro.competenceStatus === "" || filtro.competenceStatus === null) {
      filtro.competenceStatus = "VIGENTE";
    }

    if (filtro.competence === "" || filtro.competence === null) {
      filtro.competence = "";
    }

    if (filtro.insumoId === "" || filtro.insumoId === null) {
      filtro.insumoId = 0;
    }

    if (filtro.usoDoInsumo === null) {
      filtro.usoDoInsumo = "";
    }

    if (filtro.categoria === null) {
      filtro.categoria = "";
    }

    this.filterParams = {
      email: filtro.email,
      segment: filtro.segment,
      name: filtro.insumoName,
      status: filtro.status,
      competence: filtro.competence,
      competenceStatus: filtro.competenceStatus,
      id: filtro.insumoId,
      userId: 0,
      usoDoInsumo: filtro.usoDoInsumo,
      categoria: filtro.categoria,
    };
  }

  filterCategorias(value: string) {
    const filterValue = (value || '').toUpperCase();
    this.filteredCategorias = this.categoriaOptions.filter(cat =>
      cat.toUpperCase().includes(filterValue)
    );
  }

  getInsumosFieldsSegmento() {
    this.insumoFieldService.getByType("SEGMENTO").subscribe((data) => {
      this.insumoSegmentList = data
        .map((item: TablePeriodicElement) => item.fieldDescription)
        .filter((value) => value !== "Todos")
        .sort((a: string, b: string) => a.localeCompare(b, 'pt-BR'));
    });
  }

  async getInsumosForDownload() {
    const filtro = this.formFiltro.value;
    this.validationFilterRequisition();

    await this.insumosService
      .getInsumoPageableConsult(
        0,
        -1,
        this.sort.active,
        this.sort.direction,
        filtro.insumoName,
        0,
        filtro.email,
        filtro.segment,
        filtro.status,
        filtro.competence,
        filtro.competenceStatus,
        filtro.insumoId,
        filtro.usoDoInsumo || "",
        filtro.categoria || ""
      )
      .toPromise()
      .then((data) => {
        this.dataSourceForDownload = new MatTableDataSource(data["content"]);
      });
  }

  exportToExcel(model: string) {
    const filtro = this.formFiltro.value;
    this.validationFilterRequisition();
    const userId = 0;

    this.accountService.getTokenWithLowExpiration().subscribe((data) => {
      const link = `${environment.apiUrl}/insumo/export?&name=${filtro.insumoName}&userId=${userId}&email=${filtro.email}&segment=${filtro.segment}&competence=${filtro.competence}&insumoId=${filtro.insumoId}&model=${model}&token=${data.token}&exportType=consultar-insumos&statusString=${filtro.status}&competenceStatusString=${filtro.competenceStatus}&usoDoInsumo=${filtro.usoDoInsumo || ''}&categoria=${filtro.categoria || ''}`;

      window.open(link, "_blank");
    });
  }

  uploadAnexoInsumo(insumo: any) {
    this.insumo = insumo;
    this.actualInsumoLength = insumo.attachments.length;
  }

  selectInsumoVersion(insumo: any) {
    this.insumo = insumo;
    this.insumo["insumoAnexos"].forEach((element) => {
      this.insumoVersionList.push("v" + element.version);
    });

    return;
  }

  insumoAtraso(element) {
    const date = new Date().getTime();
    const deadline = new Date(element.deadline).getTime();

    if (date > deadline) {
      return true;
    }

    return false;
  }

  editPermission(responsibleUser?: string) {
    if (
      responsibleUser === this.user.email ||
      this.user.userType == "EQUIPE_INTERNA" ||
      this.user.userType == "OPERACAO_BPO"
    ) {
      return false;
    }

    return true;
  }

  isOperador() {
    if (this.user.userType === "OPERACAO_VIVO") {
      return false;
    } else if (this.user.userType === "OPERADOR_VIVO_JURIDICO") {
      return false;
    } else if (this.user.userType === "OPERADOR_VIVO_AUDITORIA") {
      return false;
    } else {
      return true;
    }
  }

  populateInsumo(data: InsumoList) {
    this.insumo = data;
  }

  onSubmit(): void {
    let updateAnexosInsumoDto: any = {};

    if (this.actualInsumoLength > 0) {
      if (this.anexoInsumo.invalid) {
        return;
      }

      updateAnexosInsumoDto = {
        userId: this.user.id,
        anexos: this.attachments,
        justificativa: this.anexoInsumo.get("justify").value,
        insumoId: this.insumo.id,
      };
      this.insumosService
        .updateAnexos(updateAnexosInsumoDto)
        .subscribe(() => this.OnInitializeDataSource());

      this.anexoInsumo.reset();
    } else {
      updateAnexosInsumoDto = {
        userId: this.user.id,
        anexos: this.attachments,
        justificativa: "",
        insumoId: this.insumo.id,
      };

      this.insumosService
        .updateAnexos(updateAnexosInsumoDto)
        .subscribe(() => this.OnInitializeDataSource());
    }
    this.attachments = [];
    this.files = [];
    this.closeConfirmDoc.nativeElement.click();
  }

  get formUp(): { [key: string]: AbstractControl } {
    return this.formUpdate.controls;
  }

  desativarInsumo(insumoId: any) {
    this.insumosService.inativarInsumo(insumoId).subscribe(() => {
      this.OnInitializeDataSource();
    });
  }

  getInsumoById(id) {
    this.insumosService.getInsumoById(id).subscribe((data) => {
      this.insumo = data as unknown as InsumoList;
      this.actualInsumoLength = data.attachments.length;
    });
  }

  excluirInsumo() {
    this.insumosService.deleteInsumo(this.tempInsumoId).subscribe((data) => {
      this.OnInitializeDataSource();
      this.tempInsumoId = null;
      this.closeModalExcluir.nativeElement.click();
    });
  }

  encerrarInsumos() {
    const userType = this.user.userType;

    if (this.selection.selected.length <= 0) {
      this.closeModalEncerrar.nativeElement.click();
      this.encerradosNada.nativeElement.click();
      return;
    }

    this.selection.selected.forEach((element, index) => {
      if (userType == "EQUIPE_INTERNA" || userType == "OPERACAO_BPO") {
        const closeInsumoDto = {
          insumoId: element.id,
          userId: this.user.id,
        };

        this.insumosService.closeInsumo(closeInsumoDto).subscribe(() => {
          if (index === this.selection.selected.length - 1) {
            this.OnInitializeDataSource();
            this.selection.clear();
            this.closeModalEncerrar.nativeElement.click();
          }
        });
      }
    });
  }

  onSubmitUpdate(): void {
    this.submitted = true;

    if (this.formUpdate.invalid) {
      return;
    }

    let tempAlterarResponsavel: any = {
      insumosId: this.actualInsumoId,
      responsibleUser: this.user.email,
      responsibleUpload: this.formUpdate.get("responsibleUpload").value,
      // null = não alterado (backend mantém o atual); "" = remover
      secondResponsibleUpload: this.formUpdate.get("secondResponsibleUpload").value,
      analysisUpload: this.formUpdate.get("analysisUpload").value,
      justify: this.formUpdate.get("justify").value,
    };

    this.submitted = false;
    this.formUpdate.get("secondResponsibleUpload").setValue(null);
    this.secondResponsibleInput?.reset();
    this.updatedInsumoResponsavel(tempAlterarResponsavel);
  }

  onSubmitDeadLine(): void {
    this.submitted = true;

    if (this.formDeadLine.invalid) {
      return;
    }

    let tempAlterarDeadLine: any = {
      insumosId: this.actualInsumoId,
      responsibleUser: this.user.email,
      deadline: this.formDeadLine.get("deadline").value,
      justify: this.formDeadLine.get("justify").value,
    };

    this.submitted = false;
    this.updatedInsumoDeadline(tempAlterarDeadLine);
  }

  setEmailResponsibleUpload(user) {
    this.formUpdate.get("responsibleUpload").setValue(user.email);
  }

  setEmailAnalysisUpload(user) {
    this.formUpdate.get("analysisUpload").setValue(user.email);
  }

  setEmailResponsavel(user) {
    this.formFiltro.get("email").setValue(user.email);
  }

  resetField(form) {
    if (form === 1) {
      this.formUpdate.get("responsibleUpload").reset();
      this.searchUserCtrl1.reset();
    } else if (form === 2) {
      this.formUpdate.get("analysisUpload").reset();
      this.searchUserCtrl2.reset();
    } else {
      this.formFiltro.get("analysisUpload").reset();
      this.searchUserCtrlFiltro.reset();
    }
  }

  updatedInsumoResponsavel(insumoResponsavelDto) {
    this.insumosService
      .updateResponsavel(insumoResponsavelDto)
      .subscribe(() => {
        this.closeModalAlterarResponsavel.nativeElement.click();
        this.actualInsumoId = null;
        this.OnInitializeDataSource();
      });
  }

  updatedInsumoDeadline(insumoDeadLineDto) {
    this.insumosService.updateDeadLine(insumoDeadLineDto).subscribe(() => {
      this.closeModalAlterarDeadLine.nativeElement.click();
      this.actualInsumoId = null;
      this.OnInitializeDataSource();
    });
  }

  //uploads

  somArray = (list: any[]) => {
    let total = 0;
    list.map((item) => (total += item.progress));

    return total / list.length;
  };

  removeAnexoFormPreUpload(file: any) {
    this.attachments = this.attachments.filter(
      (item) => item.originalFileName !== file.originalFileName
    );
    this.files = this.files.filter(
      (item) => item.data.name !== file.originalFileName
    );
  }

  removeFile(file: any) {
    this.attachments = this.attachments.filter(
      (item) => item.originalFileName !== file.originalFileName
    );
    this.files = this.files.filter(
      (item) => item.data.name !== file.originalFileName
    );
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append("file", file.data);
    file.inProgress = true;
    const fileBytes = file.data.size;

    this.uploadService.validationAws().subscribe((keys) => {
      const splitFileName = String(file.data.name).split(".");
      const mimeType = splitFileName[splitFileName.length - 1];
      const fileKey = uuid.v4();
      const fileName = String(file.data.name);

      this.uploadService
        .uploadFileInS3(file.data, fileKey, mimeType, keys)
        .on("httpUploadProgress", function (progress) {
          let progressPercentage = Math.round(
            (progress.loaded / progress.total) * 100
          );
          file.progress = progressPercentage;
        })
        .promise()
        .then(() => {
          this.uploadService
            .uploadInsumoAnexoS3(this.user.id, fileKey, fileName)
            .subscribe((body) => {
              this.attachments.push(body);
            });
        })
        .catch((error) => {
          file.inProgress = false;
          alert(`Erro ao anexar arquivo "${file.data.name}". Por favor, tente novamente.`);
          console.error('Erro no upload S3:', error);
        });
    });
  }

  private uploadFiles() {
    this.fileUpload.nativeElement.value = "";
    this.files.forEach((file) => {
      this.uploadFile(file);
    });
  }

  onUploadButtonClick() {
    this.files = [];
    const fileUpload = this.fileUpload.nativeElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({ data: file, inProgress: false, progress: 0 });
      }
      this.uploadFiles();
    };
    // fileUpload.click();
  }

  //uploads
  downloadFileNotification(fileId, insumoid) {
    this.insumosService
      .downloadNotification(this.user.id, insumoid, fileId)
      .subscribe(() => {
        console.log("Send notification");
      });

    this.downloadFile(fileId);
  }

  downloadFile(fileId: any) {
    this.accountService.getTokenWithLowExpiration().subscribe((data) => {
      const urlToDownloadFile: string = `${this.anexoDownload}${fileId}?token=${data.token}`;

      window.open(urlToDownloadFile);
    });
  }

  downloadFileInsumoContent(data: any) {
    const insumoVersion: number = Number(data.version.replace("v", ""));
    const file = data.attachments.find(
      (insumo) => insumo.version === insumoVersion
    );

    this.insumosService
      .downloadNotification(this.user.id, data.id, file.id)
      .subscribe(() => console.log("Send notification"));
    this.downloadFile(file.id);
  }
  changeVersion() {
    if (this.formChangeVersion.invalid) {
      return;
    }

    const insumoVersionDto = {
      insumosId: this.actualInsumoId,
      userId: this.user.id,
      version: this.formChangeVersion.get("version").value,
      justificativa: this.formChangeVersion.get("justificativa").value,
    };

    this.insumosService.updateVersion(insumoVersionDto).subscribe(() => {
      this.closeModalVersion.nativeElement.click();
      this.formChangeVersion.reset();
      this.actualInsumoId = null;
      this.OnInitializeDataSource();
    });
  }

  getInsumoWithVersion(insumoAnexos: any[], version: string) {
    return insumoAnexos.find((item) => item.version == version);
  }

  //table Content
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;

    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: InsumoList): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  columnsToDisplay = [
    "select",
    "id",
    "name",
    "publico",
    "segment",
    "competence",
    "deadline",
    "version",
    "dataDeUpload",
    "responsavel",
    "actions",
  ];

  displayedColumnsInterno: string[] = [
    "idArquivo",
    "nomeArquivo",
    "Justificativa",
    "dataEHoraEnvio",
    "versao",
    "acoes",
  ];
}
